export const JSON_ONE = {
   
  
    "me_id": 202104210302,
    "txn_details": "Paygate|202104210302|96692adf|1600|IND|INR|SALE| http://localhost/safexpay/Response.php| http://localhost/safexpay/Response.php|WEB",
    "pg_details": "|||",
    "cust_details": "Tommy|tommy@gmail.com|9999555666||Y",
    "bill_details": "Flat No.144,Gurukripa Apartments|Sangjo|Maharashtra|India|400013",
    "ship_details": "||||||",
    "item_details": "||",
    "card_details": "||||",
    "other_details": "||||",
    "upi_details": null
    }



